import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { LoadingProvider, ModalStatus, TrialAwarenessWidget } from '~/atomic';
import Routes from '~/routes';
import { registerFeedbackNavigator, registerUnauthorizedHandler } from '~/services';
import { useAppDispatch, useAppSelector } from '~/store';
import { logout } from '~/store/auth/login/slices';
import { clearUser } from '~/store/user/slices';
import { clearEntitlements } from '~/store/entitlements/slices';
import { fetchEntitlements } from '~/store/entitlements/thunks';
import { selectIsLoggedIn } from '~/store/auth/login/selectors';

export default function App() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isLoggedIn = useAppSelector(selectIsLoggedIn);
  const isCalculatorPublicRoute =
    pathname === '/financeiro/calculadora' || pathname === '/financeiro/calculadora/';

  useEffect(() => {
    if (isCalculatorPublicRoute) return;

    registerUnauthorizedHandler(() => {
      dispatch(logout());
      dispatch(clearUser());
      dispatch(clearEntitlements());
      navigate('/auth/login', { replace: true });
    });
    registerFeedbackNavigator((path) => navigate(path));
  }, [dispatch, isCalculatorPublicRoute, navigate]);

  useEffect(() => {
    if (isLoggedIn && !isCalculatorPublicRoute) {
      void dispatch(fetchEntitlements());
    }
  }, [dispatch, isCalculatorPublicRoute, isLoggedIn]);

  if (isCalculatorPublicRoute) {
    return <Routes />;
  }

  return (
    <>
      <Routes />
      <TrialAwarenessWidget />
      <ModalStatus />
      <LoadingProvider />
    </>
  );
}
